import type {envManager} from '../../../utils/env';
import type {platform} from '../../../utils/platform';

export abstract class EnvProviderService {
  abstract get app(): typeof envManager;
  abstract get platform(): typeof platform;
}
